import { css } from '@emotion/core';
import styled from '@emotion/styled';

const logoStyles = css`
  margin-right: 8px;
  position: relative;
  top: 8px;
`;

/**
 * Component style declarations
 */
export const Logo = styled('img')(logoStyles);
